import React from "react";
import { Result } from "antd";

const PageNotFound = () => {
  return (
    <React.Fragment>
      <Result status="warning" title="404" subTitle="Sorry, the page you visited does not exist." />
    </React.Fragment>
  );
};

export default PageNotFound;
